var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column",class:_vm.width},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }